import DropdownText from 'components/DropdownText'
import React from 'react'
import ArticleChunkAnchor from 'pages/Article/Content/components/ChunkAnchor/index.js'
import hasReferencesStrUtil from 'pages/Article/Content/utils/has-references/index.js'
import getChunkMarkdownObjUtil from 'pages/Article/Content/components/ChunkMarkdown/utils/get-chunk-markdown-obj/index.js'

/**
 * @param props
 * @param props.chunk
 * @param props.url
 * @return {React.JSX.Element}
 * @constructor
 */
export function ArticleChunkMarkdown (props) {
  const {
    chunk,
    url
  } = props
  const chunkAnchorMarkdownObj = getChunkMarkdownObjUtil(chunk)
  const html = chunkAnchorMarkdownObj.chunkMarkdown

  if (!html) {
    return <></>
  }

  if (hasReferencesStrUtil(chunk)) {
    return (
      <DropdownText
        title='References →'
        textStyle={{
          fontSize: '1.22em',
          fontWeight: '300',
          color: 'rgb(102, 102, 102)'
        }}
      >
        <div
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </DropdownText>
    )
  }

  return (
    <>
      <ArticleChunkAnchor
        url={url}
        chunkAnchorMarkdownObj={chunkAnchorMarkdownObj}
      />
      <div
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </>
  )
}
